import axios from "axios";
import { refreshSession } from "./authClient";

const API_BASE = process.env.REACT_APP_API_URL || "";

const apiClient = axios.create({
    baseURL: API_BASE,
    withCredentials: true
});

apiClient.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalRequest = error.config;
        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true;
            try {
                await refreshSession();
                return apiClient(originalRequest);
            } catch (refreshError) {
                window.location.href = "/login";
                return Promise.reject(refreshError);
            }
        }
        return Promise.reject(error);
    }
);

export async function getInsights(signal) {
    const resp = await apiClient.get("/api/insights", { signal });
    return resp.data;
}

export async function updateInsightStatus(id, status) {
    const resp = await apiClient.patch(`/api/insights/${id}`, { status });
    return resp.data;
}

export async function refreshInsights() {
    const resp = await apiClient.post("/api/insights/refresh");
    return resp.data;
}

export async function getFeatures(signal) {
    const resp = await apiClient.get("/api/features", { signal });
    return resp.data;
}
